import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(
  (theme) => ({
    root: {
      minWidth: 'auto',
      padding: '0 15px',

      '&[aria-selected="true"]': {
        '& $label': {
          color: theme.palette.primary.main,
        },
      },
    },
    label: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
    },
  }),
  { name: 'CommonNavBarButton' }
);
